import {
	SET_RESET_MODEL,
	SET_NEW_MODEL,
	SET_LOADING_RESERVATION,
	SET_LOADING_NOTA,
	SET_NOTA,
	SET_LOADING_REVIEWS,
	SET_REVIEWS
} from "./contants";
import api from "@/api.js";
export default {
	_fetchModel: async (
		{ commit, dispatch },
		{ context, modelId, copyFromId }
	) => {
		if (modelId === -1 && copyFromId === -1) return null;
		commit(SET_RESET_MODEL);
		const reservationId = modelId !== -1 ? modelId : copyFromId;
		commit(SET_LOADING_RESERVATION, true);
		return api(context)
			.get(`/reservations/${reservationId}`)
			.then(async res => {
				if (modelId !== -1) {
					await dispatch("_configEditMode", res);
				} else {
					await dispatch("_configCloneMode", res);
				}
				commit(SET_LOADING_RESERVATION, false);
				return true;
			})
			.catch(e => {
				commit(SET_LOADING_RESERVATION, false);
				context.$root.handleRequestError(e);
				return false;
			});
	},
	_fetchNotes: async ({ commit }, { context, modelId }) => {
		if (modelId !== -1) {
			commit(SET_LOADING_NOTA, true);
			return api(context)
				.get(`/reservations/${modelId}/reservation-notes`)
				.then(async res => {
					commit(SET_NOTA, res.data);
					commit(SET_LOADING_NOTA, false);
					return true;
				})
				.catch(e => {
					commit(SET_LOADING_NOTA, false);
					context.$root.handleRequestError(e);
					return false;
				});
		}
	},
	_fetchReviews: async ({ commit }, {context, modelId }) => {
		if (modelId !== -1) {
			commit(SET_LOADING_REVIEWS, true);
			return api(context)
				.get(`/reservations/${modelId}/reviews`)
				.then(async res => {
					commit(SET_REVIEWS, res.data);
					commit(SET_LOADING_REVIEWS, false);
					return true;
				})
				.catch(e => {
					commit(SET_LOADING_REVIEWS, false);
					context.$root.handleRequestError(e);
					return false;
				});
		}
	},
	_configEditMode: async ({ commit }, res) => {
		let auxViewModel = JSON.parse(JSON.stringify(res.data));
		auxViewModel.clientFirstName = res.data.client.firstName;
		auxViewModel.clientLastName = res.data.client.lastName;
		auxViewModel.clientPhone = res.data.client.phone;
		auxViewModel.clientEmail = res.data.client.email;
		auxViewModel.clientLang = res.data.client.lang;
		auxViewModel.clientBillingInfo = res.data.client.billingInfo;
		const transportServices = auxViewModel.transportServices.map(
			service => ({
				...service,
				pickupPlaceId: undefined,
				dropoffPlaceId: undefined
			})
		);
		auxViewModel.transportServices = [];
		auxViewModel.transportServices = transportServices
		return commit(SET_NEW_MODEL, auxViewModel);
	},
	_configCloneMode: async ({ commit }, res) => {
		let auxViewModel = JSON.parse(JSON.stringify(res.data));
		auxViewModel.clientFirstName = res.data.client.firstName;
		auxViewModel.clientLastName = res.data.client.lastName;
		auxViewModel.clientPhone = res.data.client.phone;
		auxViewModel.clientEmail = res.data.client.email;
		auxViewModel.clientLang = res.data.client.lang;
		auxViewModel.clientBillingInfo = res.data.client.billingInfo;

		auxViewModel.id = -1;
		auxViewModel.status = "active";
		for (let i = 0; i < auxViewModel.transportServices.length; i++) {
			auxViewModel.transportServices[i].id = -1;
			auxViewModel.transportServices[i].status = "active";
			auxViewModel.transportServices[i].serviceNumber = "";
			auxViewModel.transportServices[i].supplierConfirmation = "pending";
			auxViewModel.transportServices[i].pickupDatetimeConfirmed = false;
			auxViewModel.transportServices[i].pickupPlaceId = undefined;
			auxViewModel.transportServices[i].dropoffPlaceId = undefined;
			delete auxViewModel.transportServices[i].reservationId;
		}
		return commit(SET_NEW_MODEL, auxViewModel);
	}
};
